import React from 'react'
import styles from './ContentBlock.scss'
import Background from './Background'


const ContentBlock = ({ children, backgroundType}) => (
  <Background type={backgroundType}>
  <div className={styles.wrapper}>
      <div className={styles.content}>
      {children}
      </div>
    </div>
    </Background>
)

export default ContentBlock;